/** Just Brilliant commerce coordination: cart controls and responsive cart count. */
(function () {
  'use strict';

  function syncCartCounts() {
    const source = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (!source) return;

    document.querySelectorAll('[data-cart-drawer-toggle] .thb-item-count').forEach(function (count) {
      if (count === source) return;
      count.innerHTML = source.innerHTML;
    });
  }

  function init() {
    syncCartCounts();
    const source = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (source && window.MutationObserver) {
      new MutationObserver(syncCartCounts).observe(source, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    document.addEventListener('cart:item-added', syncCartCounts);
    document.addEventListener('cart:refresh', syncCartCounts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
